import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery } from '../styles';
import ToolCard from './ToolCard';

const StyledToolList = styled.section`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.large`
    gap: 40px;
  `}

  ${minBreakpointQuery.xxlarge`
    gap: 50px;
  `}
`;

const ToolList = ({ items }) => (
  <StyledToolList>
    {items.map(({ featuredImage, overline, title, summary, link }, id) => (
      <ToolCard
        key={id}
        image={featuredImage}
        overline={overline}
        title={title}
        summary={summary}
        link={link}
      />
    ))}
  </StyledToolList>
);

export default ToolList;
